import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import { useState, useEffect } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Alert from "@mui/material/Alert";
import CheckIcon from "@mui/icons-material/Check";

// Router
import { Link, useNavigate } from "react-router-dom";
// Image
import tvc_Logo from "../photos/tvc_logo.png";

import loginCover from "../photos/login_cover.jpg";

export default function ChangePass() {
  const baseURL = process.env.REACT_APP_BASE_URL;

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setConfirmShowPassword] = useState(false);

  const [password, setPassword] = useState("");

  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleClickShowConfirmPassword = () =>
    setConfirmShowPassword((show) => !show);

  const [user, setUser] = useState({ user_password: "" });

  const [passwordsMatch, setPasswordsMatch] = useState(true);

  const [message, setMessage] = useState("");
  const [isSuccess, setisSuccess] = useState();
  const navigate = useNavigate(); // Initialize useNavigate for redirect

  useEffect(() => {
    setPasswordsMatch(user.user_password === password);
  }, [user?.user_password]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get("token");

    if (!token) return navigate("*");

    axios
      .post(`${baseURL}/changePassword`, {
        token: token,
        new_password: password, // get this from your input field or state
      })
      .then((response) => {
        setisSuccess(true);
        setMessage(response.data.message);
      })
      .catch((error) => {
        setisSuccess(false);
        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          setMessage(error.response.data.message);
        } else {
          setMessage("An unexpected error occurred.");
        }
      });

    // try {
    //   // Send login request to the backend
    //   const response = await axios.post(`${baseURL}/checkEmail`, user, {
    //     withCredentials: true, // This enables cookies to be sent and received
    //   });
    //   setMessage(response.data.message); // Display login success message
    //   // Save access token in memory (avoid localStorage/sessionStorage for sensitive data)
    // } catch (error) {
    //   // Handle error response
    //   if (error.response) {
    //     setMessage(error.response.data.error); // Display error message from backend
    //   } else {
    //     setMessage("Login failed. Please try again.");
    //   }
    // }
  };

  const handleClick = () => {
    navigate("/");
  };

  return (
    <Box
      component="form"
      sx={{
        "& > :not(style)": { m: 1, width: "55ch" },
      }}
      display="flex"
      alignItems={"center"}
      justifyContent={"center"}
      flexDirection={"column"}
      width={"100%"}
      noValidate
      autoComplete="off"
      onSubmit={handleSubmit}
    >
      <img
        src={tvc_Logo}
        alt="The Vintage Collective"
        onClick={handleClick}
        style={{ cursor: "pointer" }}
      />
      {message == "" ? (
        ""
      ) : (
        <Alert severity={isSuccess ? "success" : "error"}>{message}</Alert>
      )}
      <span>{user.user_email}</span>
      <TextField
        id="outlined-basic"
        label="Password"
        type={showPassword ? "text" : "password"}
        variant="outlined"
        value={password}
        onChange={(event) => {
          setPassword(event.target.value);
        }}
        slotProps={{
          input: {
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label={
                    showPassword ? "hide the password" : "display the password"
                  }
                  onClick={handleClickShowPassword}
                  edge="end"
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          },
        }}
      />
      <TextField
        id="outlined-basic"
        label="Confirm Password"
        type={showConfirmPassword ? "text" : "password"}
        variant="outlined"
        value={user.user_password}
        onChange={(event) => {
          setUser({ ...user, user_password: event.target.value });
        }}
        error={user?.user_password?.length > 0 && !passwordsMatch}
        helperText={
          user?.user_password?.length > 0 && !passwordsMatch
            ? "Passwords do not match"
            : ""
        }
        slotProps={{
          input: {
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label={
                    showConfirmPassword
                      ? "hide the password"
                      : "display the password"
                  }
                  onClick={handleClickShowConfirmPassword}
                  edge="end"
                >
                  {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          },
        }}
      />
      <Button variant="contained" type="Submit">
        Change Password
      </Button>
      <span>
        Are you new here? <Link to={"/register"}>Sign up here!</Link>
      </span>
    </Box>
  );
}
